<template>
    <div class="index bg-light" style="min-height:100vh;">
        <div class="bg-white h-24 border-b border-solid border-gray-300 flex items-center">
            <div class="container p-8 mx-auto">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                            Startside
                        </h2>
                    </div>
                    <div class="mt-4 flex md:mt-0 md:ml-4">
                        <span class="ml-3 shadow-sm rounded-md">
                            <router-link tag="button" :to="{name: 'CreateSwop'}" type="button" class="bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white">
                                <div class="flex items-center">
                                    Opret SWOP
                                </div>
                            </router-link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content overflow-y-auto" style="height:calc(100vh - 10rem);-webkit-overflow-scrolling:touch;">
            <div class="container p-8 mx-auto bg-light">
                <div class="flex flex-wrap -mx-4" v-if="swops && swops.length > 0">
                    <div class="w-1/3 px-4 mb-8 outline-none focus:outline-none hover:outline-none" v-for="swop in swops" :key="swop.id">
                        <router-link tag="div" :to="{name: 'SingleSwop', params: {id: swop.id}}" class="swop-card overflow-hidden bg-white shadow rounded leading-5">
                            <!--<div class="py-4 px-6 text-white" style="background:#172b43;">
                                {{ swop.worker.name }}
                            </div>-->
                            <div class="flex justify-end">
                                <div v-if="swop.worker.color" class="w-full text-white py-2 px-6 text-sm text-center" style="background:#ff0046;" :style="'background:' + swop.worker.color">
                                    {{ swop.worker.name }}
                                </div>
                                <div v-else class="w-full text-white py-2 px-6 text-sm text-center bg-main">
                                    {{ swop.worker.name }}
                                </div>
                            </div>
                            <div class="inner p-4">
                                <div class="flex justify-between text-gray-500">
                                    <div>
                                        ID: {{ swop.id }}
                                    </div>
                                    <div>
                                        {{ timeFromNow(swop.created_at) }}
                                    </div>
                                </div>
                                <div class="text-3xl text-center font-semibold my-4 text-gray-900">
                                    {{ swop.serial }}
                                </div>
                                <div class="flex justify-between text-gray-500">
                                    <div>
                                        {{ swop.container.name }}
                                    </div>
                                    <div>
                                        <!--<div class="inline mr-4">
                                            <i class="fas fa-wrench" />
                                            {{ swop.parts.length }}
                                        </div>-->
                                        <div class="inline">
                                            {{ swop.tests.length }}
                                            <span v-if="swop.tests.length === 1">test</span>
                                            <span v-else>tests</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as swopService from '@/services/swopService'
import moment from 'moment'

export default {
    data () {
        return {
            swops: [],
            emojis: [
                'angry',
                'dizzy',
                'flushed',
                'frown',
                'frown-open',
                'grimace',
                'grin',
                'grin-alt',
                'grin-beam',
                'grin-beam-sweat',
                'grin-hearts',
                'grin-squint',
                'grin-squint-tears',
                'grin-stars',
                'grin-tears',
                'grin-tongue',
                'grin-tongue-squint',
                'grin-tongue-wink',
                'grin-wink',
                'kiss',
                'kiss-beam',
                'kiss-wink-heart',
                'laugh',
                'laugh-beam',
                'laugh-squint',
                'laugh-wink',
                'meh',
                'meh-blank',
                'meh-rolling-eyes',
                'sad-cry',
                'sad-tear',
                'smile',
                'smile-beam',
                'smile-wink',
                'surprise',
                'tired'
            ]
        }
    },
    created () {
        this.getSwops()
    },
    methods: {
        getSwops () {
            swopService.active(null, (response) => {
                this.swops = response.data
                console.log(response.data)
            }, (err) => {
                // Handle error
                console.log(err)
            })
        },
        timeFromNow (date) {
            let output = moment(date).fromNow()
            let output1 = output.replace(' siden', '')
            let output2 = output1.replace('minutter', 'min.')
            return output2
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?521b9a71